import type { ReactElement } from 'react';
import Dialog, { type DialogProps } from '@fastnorth/kraken/components/dialog';
import { Div } from '@fastnorth/kraken/components/layout';
import { ThumbnailImage } from '@fastnorth/kraken/components/image';
import { Paragraph } from '@fastnorth/kraken/components/typography';
import { useTranslation } from 'react-i18next';

type FollowedLimitDialogPropsType = Pick<DialogProps, 'open'> & {
  participantName?: string;
  onOpenChange: (open: boolean) => void;
};

const FollowedLimitDialog = ({
  participantName,
  onOpenChange,
  open,
}: FollowedLimitDialogPropsType): ReactElement => {
  const { t } = useTranslation('translation', {
    keyPrefix: 'karwa.following.followed_limit_dialog',
  });

  return (
    <Dialog
      open={open}
      onOpenChange={onOpenChange}
      dialogTitle={{ text: t('title') }}
      footer={[{ children: t('confirm_button') }]}>
      <Div className={'flex flex-col items-center'} spacing={'5 4'}>
        <ThumbnailImage
          src={'https://cdn.raceroster.com/assets/cerbicons/bulk-uploader-participants.svg'}
          alt={''}
          variant={'circle'}
          size={'md'}
          spacing={'0 0 5'}
        />
        <Paragraph type={'lead'} align={'center'} spacing={'0 0 4'}>
          {t('limit_message')}
        </Paragraph>
        {participantName && (
          <Paragraph align={'center'}>{t('unfollow_message', { participantName })}</Paragraph>
        )}
      </Div>
    </Dialog>
  );
};

export default FollowedLimitDialog;
